import { Add } from "@mui/icons-material";
import { IconButton, Stack } from "@mui/material";
import { SelectableChip } from "components/SelectableChip/SelectableChip";
import { EmailTemplatesListProps } from "./EmailTemplatesList.type";

export function EmailTemplatesList({
  templates,
  selectedTemplateId,
  isDeleting,
  onClickAdd,
  onClick,
  onDelete,
}: EmailTemplatesListProps) {
  return (
    <Stack gap={1} flexWrap={"wrap"} direction={"row"}>
      {templates.map((template) => (
        <SelectableChip
          key={template.id}
          label={template.name}
          selected={selectedTemplateId === template.id}
          isDeleting={isDeleting && selectedTemplateId === template.id}
          onClick={() => onClick(template)}
          onDelete={() => onDelete(template)}
        />
      ))}
      {onClickAdd && (
        <IconButton
          size="small"
          color={!selectedTemplateId ? "primary" : "default"}
          sx={{
            backgroundColor: !selectedTemplateId ? "secondary.dark" : undefined,
          }}
          onClick={onClickAdd}
        >
          <Add fontSize={"small"} color={"secondary"} />
        </IconButton>
      )}
    </Stack>
  );
}
